import { PRIORITY_CASH_CROPS } from '@cibo/core'
import { useCiboAutoForm } from '@cibo/ui'
import {
  Autocomplete,
  AutocompleteRenderInputParams,
  FormControl,
  FormLabel,
  TextField,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { connectField, filterDOMProps, useFormContext } from 'dynamic-uniforms'
import { COVER_CROP_OPTIONS } from './types'

export const CoverCropInput = (props: any) => {
  const { name, label, required, disabled } = props

  const { t } = useTranslation(['@cibo/landmanager/CoverCropEditor', '@cibo/ui/cropNames'])

  const { model, onChange } = useFormContext()
  const { touch } = useCiboAutoForm()

  const modelIsPreventPlant = (model.value as { preventPlant?: boolean })?.preventPlant

  return (
    <>
      <FormControl fullWidth {...filterDOMProps(props)} required={required} disabled={disabled}>
        <FormLabel component="legend" htmlFor={name}>
          {label || t('title')}
        </FormLabel>
        <Autocomplete
          renderInput={(params: AutocompleteRenderInputParams) => (
            <TextField name={name} {...params} />
          )}
          groupBy={crop => (PRIORITY_CASH_CROPS.includes(crop as any) ? t('suggested') : t('all'))}
          options={COVER_CROP_OPTIONS}
          getOptionLabel={(option: string) => t(option, { ns: '@cibo/ui/cropNames' })}
          data-testid={`crop`}
          selectOnFocus
          onChange={(_, newValue) => {
            onChange('value.crop', newValue === null ? undefined : newValue)
          }}
          value={modelIsPreventPlant ? 'preventPlant' : props.value || ''}
          onBlur={() => touch(name)}
        />{' '}
      </FormControl>
    </>
  )
}

export const CoverCropField = connectField(CoverCropInput)
